import c from 'classnames';
import * as spinners from 'spinners-react';

import styles from './Spinfinity.module.css';

export const SpinnerCircular = ({
  fixed = false,
  size = 60,
  speed = 100,
  thickness = 100,
  color = 'var(--warm-grey-600)',
  secondaryColor = 'var(--warm-grey-300)',
  fullScreen = false,
}) => {
  return (
    <div
      className={c(
        styles.spinfinity,
        fixed && styles.fixed,
        fullScreen && styles.fullScreen,
      )}
      data-testid='spinfinity'
    >
      <spinners.SpinnerCircular
        size={size}
        speed={speed}
        thickness={thickness}
        secondaryColor={secondaryColor}
        color={color}
      />
    </div>
  );
};
